import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AlertComponent } from './shared/directives/alert.component';
import { AlertService } from './shared/services/alert.service';
import { AuthService } from './shared/services/auth.service';
import { UserSessionService } from './shared/services/user-session.service';
import { PushIdentityService } from './shared/services/push-identity.service';
import { AccountService } from './shared/services/account.service';
import { DatePipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ConfirmEqualValidatorDerective } from './shared/directives/confim-equal-validator.derective';
import { PasswordPolicyValidatorDirective } from './shared/directives/password-policy-validator.derective';
import { CvrValidatorDirective } from './shared/directives/cvr-validator.directive';
import { AutoFocusDirective } from './shared/directives/auto-focus-directive';
import { SettingsService } from './shared/services/settings.service';
import { DataTableService } from './shared/services/datatable.service';
import { HttpHelperService } from './shared/services/httphelper.service';
import { ErrorService } from './shared/services/error.service';
import { CareHomeService } from './shared/services/carehome.service';
import { ToastContainerComponent } from './shared/components/toast-container/toast-container.component';
import { IconDropdownComponent } from './shared/components/icon-dropdown/icon-dropdown.component';
import { MultiSelectDropdownComponent } from './shared/components/multi-select-dropdown/multi-select-dropdown.component';
import { ConfirmDialogComponent } from './shared/components/confirm-dialog/confirm-dialog.component';
import { RoleNamePipe } from './shared/pipes/role-name.pipe';
import { FileUploaderComponent } from './shared/components/file-uploader/file-uploader.component';
import { ManualEventsModalComponent } from './shared/components/manual-events-modal/manual-events-modal.component';
import { DialogService } from './shared/services/dialog.service';
import { DiaperService } from './shared/services/diaper.service';
import { DepartmentService } from './shared/services/department.service';
import { ResidentService } from './shared/services/citizen.service';
import { UserLevelDirective } from './shared/directives/user-level.directive';
import { ProfileService } from './shared/services/ProfileService';
import { UserService } from './shared/services/user.service';
import { EventConfigurationService } from './shared/services/event-configuration.service';
import { NotificationService } from './shared/services/notification.service';
import { ServiceWorkerRegisteration } from './shared/services/service.worker.registeration';
import { EventService } from './shared/services/EventService';
import { TetonService } from './shared/services/teton.service';
import { DataTableComponent } from './shared/components/data-table/data-table.component';
import { ColumnCellDirective } from './shared/components/data-table/column-cell.directive';
import { TableFooterDirective } from './shared/components/data-table/table-footer.directive';
import { CareHomeDeviceCreateComponent } from './modules/settings/admin/create/carehome-device-create.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule
  ],
  declarations: [
    AlertComponent,
    ConfirmEqualValidatorDerective,
    PasswordPolicyValidatorDirective,
    CvrValidatorDirective,
    AutoFocusDirective,
    UserLevelDirective,
    ToastContainerComponent,
    IconDropdownComponent,
    MultiSelectDropdownComponent,
    ConfirmDialogComponent,
    RoleNamePipe,
    FileUploaderComponent,
    ManualEventsModalComponent,
    DataTableComponent,
    ColumnCellDirective,
    TableFooterDirective,
    CareHomeDeviceCreateComponent
  ],
  exports: [
    AlertComponent,
    TranslateModule,
    ConfirmEqualValidatorDerective,
    PasswordPolicyValidatorDirective,
    CvrValidatorDirective,
    AutoFocusDirective,
    UserLevelDirective,
    ToastContainerComponent,
    IconDropdownComponent,
    MultiSelectDropdownComponent,
    ConfirmDialogComponent,
    RoleNamePipe,
    FileUploaderComponent,
    ManualEventsModalComponent,
    DataTableComponent,
    ColumnCellDirective,
    TableFooterDirective,
    CareHomeDeviceCreateComponent
  ],
  providers: [
    AlertService,
    AuthService,
    UserSessionService,
    AccountService,
    DatePipe,
    SettingsService,
    DataTableService,
    HttpHelperService,
    ErrorService,
    CareHomeService,
    DialogService,
    DiaperService,
    DepartmentService,
    ResidentService,
    ProfileService,
    UserService,
    EventConfigurationService,
    NotificationService,
    ServiceWorkerRegisteration,
    PushIdentityService,
    EventService,
    TetonService
  ]
})
export class SharedModule { }
